import React, { Component } from "react"
import { getCategories } from "../../services/Api"
import { ListGroup } from "react-bootstrap"
import { Link } from "react-router-dom"

class questionsFeed extends Component {
	constructor() {
		super()
		this.state = {
			categories: [],
		}
	}

	async componentDidMount() {
		const categories = await getCategories()

		console.log(categories)

		this.setState({
			categories: categories,
		})
	}

	render() {
		return (
			<React.Fragment>
				<ListGroup.Item className='feedCateGoryName'>
					<Link to='/'>Home</Link>
				</ListGroup.Item>
				<ListGroup.Item className='feedCateGoryName'>
					<Link to='/policy'>Privacy Policy</Link>
				</ListGroup.Item>
				<ListGroup.Item className='feedCateGoryName'>
					<Link to='/terms'>Terms and Condition</Link>
				</ListGroup.Item>
			</React.Fragment>
		)
	}
}

export default questionsFeed
